<template>
	<div class="mini-cart-wrapper">
		<div class="mini-cart">
			<div class="mini-cart-header shadow">
				<!-- mini-cart-open -->
				YOUR CART
				<button
					type="button"
					class="button ion ion-md-close"
					id="mini-cart-close"
				></button>
			</div>
			<ul class="mini-cart-list">
				<li class="clearfix" v-for="cart in getCarts" :key="cart.id">
					<router-link :to="{name: 'ProductDetail', params: {id: cart.product.id, slug : cart.product.product_slug}}">
						<img
							:src="API_URL + '/storage/uploads/' + (cart.product.images.length > 0 ? cart.product.images[0].name : 'no-image.png')"
							alt="Product"
							@error="$event.target.src = 'https://fl-1.cdn.flockler.com/embed/not-found.png'"
						/>
						<span class="mini-item-name">{{ cart.product.product_name }}</span>
						<span class="mini-item-price">{{ formatCurrency(cart.unit_price) }}</span>
						<span class="mini-item-quantity"> x {{ cart.qty }} </span></router-link
					>
				</li>
			</ul>
			<div class="empty-cart" v-if="getCarts.length == 0">
				<i class="fas fa-cart-arrow-down"></i>
				<p>Cart Empty</p>
			</div>
			<div class="mini-shop-total clearfix" v-if="getCarts.length != 0">
				<span class="mini-total-heading float-left">Total:</span>
				<span class="mini-total-price float-right"
					>{{ formatCurrency(getTotal) }} <span class="tax">(Include Tax)</span>
				</span>
			</div>
			<div class="mini-action-anchors" v-if="getCarts.length != 0">
				<router-link :to="{name: 'Cart'}" class="cart-anchor">View Cart</router-link>
				<router-link :to="{name: 'Checkout'}" class="checkout-anchor"
					>Checkout</router-link
				>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapGetters, mapActions} from "vuex";
	import {publicPath} from "../../../vue.config";
	import {formatCurrency} from "../../utils/common_functions"
	export default {
		data() {
			return {
				API_URL: process.env.VUE_APP_API_URL,
				publicPath: publicPath,
			};
		},
		computed: {
			...mapGetters("cart", ["getCarts", "getTotal", "openCart"]),
		},
		methods : {
			formatCurrency
		},
		mounted() {
			$("#mini-cart-trigger").on("click", function () {
				$(".mini-cart-wrapper").addClass("mini-cart-open");
			});

			$("#mini-cart-close").on("click", function () {
				$(".mini-cart-wrapper").removeClass("mini-cart-open");
			});
		},
		watch: {
			$route(to, from) {
				$(".mini-cart-wrapper").removeClass("mini-cart-open");
			},
		},
	};
</script>

<style scoped>
	.tax {
		font-size: small;
	}
	.fas {
		font-size: 4rem;
		color: #343a40;
	}
	.empty-cart p {
		font-weight: bold;
	}
	.empty-cart {
		text-align: center;
		height: 500px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.mini-cart-header {
		background-color: #343a40;
		color: white;
	}
	.mini-cart-header button {
		color: white;
	}
</style>
